<script setup lang="ts">
import { storyblokImage } from '~/utils/storyblok-image';
const props = defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
});

const { toLocaleUrl } = useLocaleUrl();

const href = computed(() => {
    if (!props.blok.link) return '#';
    // External links returned as-is, internal links transformed
    if (props.blok.link.linktype === 'url') return props.blok.link.cached_url;
    return toLocaleUrl(props.blok.link.cached_url);
});
</script>

<template>
    <a :href="href" :target="blok.link?.target">
        <article class="p-4 h-full bg-white rounded-lg shadow-xl dark:bg-midnight-blue hover:scale-105 duration-300 motion-reduce:transition-none motion-reduce:hover:transform-none">
            <img
                class="mb-5 rounded-lg h-48 w-full object-cover"
                :src="storyblokImage(blok.image.filename, { width: 768 })"
                alt="office laptop working"
            />
            
            <!-- Commenting out this until we implement tags in Storyblok-->
            <!--span
                class="bg-purple-100 text-purple-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-purple-200 dark:text-purple-900"
                >Article</span
            -->
            <h2 class="my-2 text-2xl tracking-tight text-gray-900 dark:text-white">
                {{
                    blok.title
                }}
            </h2>
            <p class="mb-4 font-light text-gray-500 dark:text-gray-400">
                {{ blok.text }}
            </p>
            <!-- Commenting out this until we implement tags in Storyblok-->
            <!--div class="flex items-center space-x-4">
                <img
                    class="w-10 h-10 rounded-full"
                    :src="blok.authorImage.filename"
                    :alt="blok.authorImage.alt"
                />
                <div class="font-medium dark:text-white">
                    <div>{{ blok.author }}</div>
                    <div class="text-sm font-normal text-gray-500 dark:text-gray-400">
                        {{ blok.publishDate }}
                    </div>
                </div>
            </div-->
        </article>
    </a>
</template>
